import { OS_ARCHITECTURES } from '@app/applicationVersions/components/options';
import { ApplicationVersionDto } from '@app/applicationVersions/dto';
import { RESOURCES } from '@constants';
import { useCustom } from '@refinedev/core';

type OS = keyof typeof OS_ARCHITECTURES;

type CpuArchitecture = (typeof OS_ARCHITECTURES)[OS][number];

export type AppVersionParams = { os: OS; cpuArchitecture: CpuArchitecture };

export const useFetchLatestAppVersion = (params: AppVersionParams) => {
  return useCustom<{ items: ApplicationVersionDto[] }>({
    url: `/client-proxy/${RESOURCES.applicationVersions}`,
    method: 'get',
    config: {
      query: {
        os: params.os,
        cpuArchitecture: params.cpuArchitecture,
        page: 1,
        size: 1,
      },
    },
    queryOptions: {
      queryKey: ['download-latest-app', params.os, params.cpuArchitecture],
    },
  });
};
